import React from "react";
import Helmet from "react-helmet";
import Main from "../../components/main";
import Box from "../../components/box";
import H1 from "../../components/h1";

class Reviews extends React.PureComponent {
  // componentDidMount() {
  //   const grid = document.getElementById("full-trustpilot-grid");
  //   const loadFromElement = () => {
  //     if (window.Trustpilot) {
  //       window.Trustpilot.loadFromElement(grid);
  //     } else {
  //       setTimeout(loadFromElement, 500);
  //     }
  //   };
  //   loadFromElement();
  // }

  componentDidMount() {
    // const mobile = document.getElementById("twitter-quote-trustbox-mobile");
    // const desktop = document.getElementById("twitter-quote-trustbox-desktop");
    const widget = document.getElementById("trustpilot-widget-free");
    const loadFromElement = () => {
      if (window.Trustpilot) {
        // window.Trustpilot.loadFromElement(mobile);
        // window.Trustpilot.loadFromElement(desktop);
        window.Trustpilot.loadFromElement(widget);
      } else {
        setTimeout(loadFromElement, 500);
      }
    };
    loadFromElement();
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <Main>
        <Helmet>
          <title>Ghast.io Reviews: Find out what people think of Ghast</title>
          <meta
            name="description"
            content="Find out why Ghast is rated excellent on Trustpilot, populated with reviews making ..."
          />
        </Helmet>
        <Box>
          <H1>
            Find out why Ghast.io is rated excellent on Trustpilot reviews
          </H1>
          {/* <P>
            Here are a selection of reviews from Trustpilot, browse through and
            soon you will learn why{" "}
            <A className="link-color" href="/">
              Ghast
            </A>{" "}
            is the most popular minecraft connection product on the market! We
            go out of our way at Ghast and AuraSide to provide top notch
            customer service, and help you along every step of the way!
          </P> */}
        </Box>
        {/* <div
          id="trustpilot-widget-free"
          class="trustpilot-widget"
          data-locale="en-GB"
          data-template-id="5419b6a8b0d04a076446a9ad"
          data-businessunit-id="5c3cae791aa59c0001976ef2"
          data-style-height="24px"
          data-style-width="100%"
          data-theme="light"
        >
          <a
            href="https://uk.trustpilot.com/review/ghast.io"
            target="_blank"
            rel="noopener"
          >
            Trustpilot
          </a>
        </div> */}

        <div
          id="trustpilot-widget-free"
          class="trustpilot-widget"
          data-locale="en-GB"
          data-template-id="5613c9cde69ddc09340c6beb"
          data-businessunit-id="5c3cae791aa59c0001976ef2"
          data-style-height="100%"
          data-style-width="100%"
          data-theme="light"
        >
          <a
            href="https://uk.trustpilot.com/review/ghast.io"
            target="_blank"
            rel="noopener"
          >
            Trustpilot
          </a>
        </div>

        {/* <div
          id="full-trustpilot-grid"
          className="trustpilot-widget"
          data-locale="en-GB"
          data-template-id="539adbd6dec7e10e686debee"
          data-businessunit-id="5c3cae791aa59c0001976ef2"
          data-style-height="500px"
          data-style-width="100%"
          data-theme="light"
          data-stars="4,5"
          data-schema-type="Organization"
          style={{ marginBottom: 40 }}
        >
          {" "}
          <a href="https://uk.trustpilot.com/review/ghast.io" target="_blank">
            Trustpilot
          </a>{" "}
        </div> */}
      </Main>
    );
  }
}

export default Reviews;



/** WEBPACK FOOTER **
 ** ./src/views/pages/reviews/index.js
 **/